// Angular
import { Component, OnInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { AuthService, currentUser, isLoggedIn, Logout } from '../../../../core/auth';
import { Observable } from 'rxjs';
import { User } from '@app/model/user';
import { CategoryService } from '@app/api/api';
import { environment } from '@app/../environments/environment';
@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {

	// @HostListener('window:scroll', ['$event'])
	// onScroll() {
	// 	this.isScrol = $(window).scrollTop() > 0 ? true : false;
	// }

	// @HostListener('window:resize', ['$event'])
	// onResize(event) {
	// 	this.isScrol = $(window).scrollTop() > 0 ? true : false;
	// }

	search: any = '';
	user$: Observable<User>;
	isLogin: boolean = false;
	isScrol: boolean = false;
	listCategory = [];
	currentUser: any = null;

	constructor(
		private router: Router,
		private store: Store<AppState>,
		private cdr: ChangeDetectorRef,
		private categoryService: CategoryService
	) { }

	backend = environment.backendhost;

	ngOnInit(): void {
		this.getListCategory()

		// isLoggedIn — có giá trị ngay khi Login action dispatch
		this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
			if (loggedIn) {
				this.isLogin = true;
			} else {
				const token = localStorage.getItem(environment.authTokenKey);
				this.isLogin = !!(token && token.length > 10);
			}
			this.cdr.detectChanges();
		});

		// currentUser — có giá trị sau khi API getMyInfo trả về
		this.user$ = this.store.pipe(select(currentUser));
		this.user$.subscribe(res => {
			if (res) {
				this.isLogin = true;
				this.currentUser = res;
			}
			this.cdr.detectChanges()
		});
	}

	getListCategory() {
		this.categoryService.apiCategoriesGet().subscribe(res => {
			if (res.success) {
				this.listCategory = res.data;
			}
		})
	}


	// nextPageSearch() {
	// 	this.router.navigate([
	// 		'/searchresultpage',
	// 	], { queryParams: { search: this.search.trim() } });

	// }

	// openNav() {
	// 	let w = '50%'
	// 	if (screen.width <= 576) {
	// 		w = '70%'
	// 	}
	// 	document.getElementById("mySidenav").style.width = w;
	// 	document.body.style.overflow = "hidden";

	// 	let div = document.createElement("div");
	// 	var att = document.createAttribute("class");
	// 	att.value = "kt-header-menu-wrapper-overlay";
	// 	div.setAttributeNode(att);
	// 	document.getElementById("slide-bar-menu").appendChild(div)
	// }

	// closeNav() {
	// 	document.getElementById("mySidenav").style.width = "0";
	// 	document.body.style.overflow = "auto"

	// 	let els = document.getElementsByClassName("kt-header-menu-wrapper-overlay");
	// 	if (els.length > 0) {
	// 		els[0].remove();
	// 	}
	// }

	// onClick(event) {
	// 	var target = event.target || event.srcElement || event.currentTarget;
	// 	if (!(document.getElementById('mySidenav').contains(target))) {
	// 		this.closeNav();
	// 	}
	// }

	// openModalSignInUp(type){
	// 	const dialogRef = this.dialog.open(ModalCreateSignInUpComponent, {
	// 		width: '900px',
	// 		data:type
	// 	  });
	// 	  dialogRef.afterClosed().subscribe(result => {
	// 		if(result!=undefined){
	// 			if (result.event) {
	// 				if(result.type =="signin"){
	// 					//this.toastr.success('Đăng nhập thành công');
	// 				  }
	// 				  else if(result.type=="signup"){
	// 						//this.toastr.success('Đăng kí thành công');
	// 				  }else{
	// 					this.toastr.success('Thực hiện thao tác thành công');
	// 				  }
	// 			}
	// 		}
	// 	  });
	// }

}
